export default __webpack_public_path__ + "static/media/step3-grey.91af977f.svg";